export default "__VITE_ASSET__jRbeiaqH__"